export default {
    name: "ProjectCard",
    props: {
        result: {
            type: Object,
            required: true
        }
    },
    setup(){
        
    }
}